import { render, staticRenderFns } from "./ManifestItem.vue?vue&type=template&id=39cf9d2f"
import script from "./ManifestItem.vue?vue&type=script&lang=js"
export * from "./ManifestItem.vue?vue&type=script&lang=js"
import style0 from "./ManifestItem.vue?vue&type=style&index=0&id=39cf9d2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports